<template>
  <div>
    <!-- 标题 -->
    <div class="ObjectStorage-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.bucketName }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/objectStorageMonitor">{{
          $t("alarms.objectStorage.objectStorage")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="ObjectStorage-top">
      <Row :gutter="16">
        <!-- AWS   -->
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
      <!--ALY  -->
      <Col span="6" v-if="isALY">
        <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
          <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <!-- GCP  -->
      <Col span="6" v-if="isGCP">
        <Select v-model="timeType" @on-change="changeTimeGTypeGCP(timeType)">
          <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? list
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : GCPList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "ObjectStorage",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // 折线图
      list: [
        {
          id: "storageSize",
          title: this.$t("alarms.objectStorage.line.StorageSizeBytes")
        },
        {
          id: "getPutRequest",
          title: this.$t(
            "alarms.objectStorage.line.GetAndPutRequestsNumberOfTimes"
          )
        },
        {
          id: "internetTX",
          title: this.$t(
            "alarms.objectStorage.line.PublicNetworkOutgoingMeteredTrafficBytes"
          )
        },
        {
          id: "syncRX",
          title: this.$t(
            "alarms.objectStorage.line.CrossRegionReplicationOfIncomingMeteredTrafficBytes"
          )
        }
      ],
      // 阿里云折线图
      alyList: [
        {
          id: "availabilityRequestValidRate",
          title: this.$t(
            "alarms.objectStorage.line.availabilityRequestValidRate"
          )
        },
        {
          id: "validRequestCountTotalRequestCount",
          title: this.$t(
            "alarms.objectStorage.line.validRequestCountTotalRequestCount"
          )
        },
        {
          id: "internetcdnsync",
          title: this.$t("alarms.objectStorage.line.internetcdnsync")
        }
      ],
      // GCP 折线图
      GCPList: [
        {
          id: "requestCount",
          title: this.$t("alarms.objectStorage.line.requestCount")
        },
        {
          id: "receivedBytesCount",
          title: this.$t("alarms.objectStorage.line.receivedBytesCount")
        },
        {
          id: "sentBytesCount",
          title: this.$t("alarms.objectStorage.line.sentBytesCount")
        },
        {
          id: "objectCount",
          title: this.$t("alarms.objectStorage.line.objectCount")
        },
        {
          id: "totalByteSeconds",
          title: this.$t("alarms.objectStorage.line.totalByteSeconds")
        },
        {
          id: "totalBytes",
          title: this.$t("alarms.objectStorage.line.totalBytes")
        }
      ],
      isAWS: false,
      isALY: false,
      isGCP: false,
      timeType: 0,
      timeList: [],
      // echarts实例
      chart: "",
      chartGetPutRequest: "",
      chartInternetTX: "",
      chartSyncRX: "",
      chartAvailabilityRequestValidRate: "",
      chartValidRequestCountTotalRequestCount: "",
      chartInternetcdnsync: "",
      storageSizeOption: {},
      getPutRequestOption: {},
      internetTXOption: {},
      syncRXOption: {},
      availabilityRequestValidRateOptions: {},
      validRequestCountTotalRequestCountOptions: {},
      internetcdnsyncOptions: {},
      // 数组
      storageSize: [],
      getRequestCount: [],
      internetTX: [],
      putRequestCount: [],
      syncRX: [],
      availabilityRequestValidRate: [],
      validRequestCountTotalRequestCount: [],
      availability: [],
      requestValidRate: [],
      validRequestCount: [],
      totalRequestCount: [],
      internetcdnsync: [],
      internetSend: [],
      internetRecv: [],
      intranetSend: [],
      intranetRecv: [],
      cdnSend: [],
      cdnRecv: [],
      syncSend: [],
      syncRecv: [],
      xaxisData: [],
      // GCP
      gcpCloudStorageApiRequestCount: [],
      gcpCloudStorageNetworkReceivedBytesCount: [],
      gcpCloudStorageNetworkSentBytesCount: [],
      gcpCloudStorageStorageObjectCount: [],
      gcpCloudStorageStorageTotalByteSeconds: [],
      gcpCloudStorageStorageTotalBytes: [],
      gcpXsData: [],

      gcpCloudStorageApiRequestCountOption: {},
      gcpCloudStorageNetworkReceivedBytesCountOption: {},
      gcpCloudStorageNetworkSentBytesCountOption: {},
      gcpCloudStorageStorageObjectCountOption: {},
      gcpCloudStorageStorageTotalByteSecondsOption: {},
      gcpCloudStorageStorageTotalBytesOption: {},

      gcpChartGcpcloudStorageApiRequestCount: "",
      gcpChartGcpcloudStorageNetworkReceivedBytesCount: "",
      gcpChartGcpcloudStorageNetworkSentBytesCount: "",
      gcpChartGcpcloudStorageStorageObjectCount: "",
      gcpChartGcpcloudStorageStorageTotalByteSeconds: "",
      gcpChartGcpcloudStorageStorageTotalBytes: "",
      colorList: ["#c23159", "#6a7985", "#91c7ae"]
    };
  },
  mounted: function() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chart.resize();
        self.chartGetPutRequest.resize();
        self.chartInternetTX.resize();
        self.chartSyncRX.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartAvailabilityRequestValidRate.resize();
        self.chartValidRequestCountTotalRequestCount.resize();
        self.chartInternetcdnsync.resize();
      });
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        // 这里面要放图表的 6 个方法
        // 请求次数
        this.gcpCloudStorageApiRequestCountEchartsLine();
        // 接受字节
        this.gcpCloudStorageNetworkReceivedBytesCountEchartsLine();
        // 发送字节数
        this.gcpCloudStorageNetworkSentBytesCountEchartsLine();
        // 对象数
        this.gcpCloudStorageStorageObjectCountEchartsLine();
        // 总字节秒数
        this.gcpCloudStorageStorageTotalByteSecondsEchartsLine();
        // 总字节数
        this.gcpCloudStorageStorageTotalBytesEchartsLine();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryBucketIndex();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.register();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryGcpCloudStorageIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function(item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "storageSize") {
            var optionFll = this.storageSizeOption;
          } else if (item.id == "getPutRequest") {
            var optionFll = this.getPutRequestOption;
          } else if (item.id == "internetTX") {
            var optionFll = this.internetTXOption;
          } else if (item.id == "syncRX") {
            var optionFll = this.syncRXOption;
          } else if (item.id == "availabilityRequestValidRate") {
            var optionFll = this.availabilityRequestValidRateOption;
          } else if (item.id == "validRequestCountTotalRequestCount") {
            var optionFll = this.validRequestCountTotalRequestCountOption;
          } else if (item.id == "internetcdnsync") {
            var optionFll = this.internetcdnsyncOption;
          }
          // GCP
          else if (item.id == "requestCount") {
            var optionFll = this.gcpCloudStorageApiRequestCountOption;
          } else if (item.id == "receivedBytesCount") {
            var optionFll = this.gcpCloudStorageNetworkReceivedBytesCountOption;
          } else if (item.id == "sentBytesCount") {
            var optionFll = this.gcpCloudStorageNetworkSentBytesCountOption;
          } else if (item.id == "objectCount") {
            var optionFll = this.gcpCloudStorageStorageObjectCountOption;
          } else if (item.id == "totalByteSeconds") {
            var optionFll = this.gcpCloudStorageStorageTotalByteSecondsOption;
          } else if (item.id == "totalBytes") {
            var optionFll = this.gcpCloudStorageStorageTotalBytesOption;
          }
          fullChart.setOption(optionFll);
          window.addEventListener("resize", function() {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function() {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        });
    },
    // 通过问题类型查询案例 AWS
    queryBucketIndex: function() {
      this.$api.bucket
        .queryBrokerSummaryById({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 4,
          bucketName: this.$route.query.bucketName,
          region: this.$route.query.region
        })
        .then(res => {
          this.storageSize = res.data.storageSize;
          this.getRequestCount = res.data.getRequestCount;
          this.putRequestCount = res.data.putRequestCount;
          this.internetTX = res.data.internetTX;
          this.syncRX = res.data.syncRX;
          this.xaxisData = res.data.xaxisData;
          this.init();
        });
    },
    // 通过问题类型查询案例 Aliyun
    register: function() {
      this.$api.cloudWatch
        .checkALIOssIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 4,
          bucketName: this.$route.query.bucketName,
          region: this.$route.query.region
        })
        .then(res => {
          this.xaxisData = res.data.xaxisData;
          this.availabilityRequestValidRate =
            res.data.availabilityRequestValidRate;

          this.availability = res.data.availability;
          this.requestValidRate = res.data.requestValidRate;
          this.validRequestCountTotalRequestCount =
            res.data.validRequestCountTotalRequestCount;
          this.validRequestCount = res.data.validRequestCount;
          this.totalRequestCount = res.data.totalRequestCount;
          this.internetcdnsync = res.data.internetcdnsync;
          this.internetSend = res.data.internetSend;
          this.internetRecv = res.data.internetRecv;
          this.intranetSend = res.data.intranetSend;
          this.intranetRecv = res.data.intranetRecv;

          this.cdnSend = res.data.cdnSend;
          this.cdnRecv = res.data.cdnRecv;
          this.syncSend = res.data.syncSend;
          this.syncRecv = res.data.syncRecv;
          this.allAws();
        });
    },
    // 7.7 tiya 新增 GCP
    // GCP 时间范围查询案例
    queryGcpCloudStorageIndex() {
      this.$api.cloudWatch
        .queryCheckGcpCloudStorageIndex({
          accountId: this.$route.query.accountId,
          bucketName: this.$route.query.bucketName,
          monitorModule: 4,
          region: this.$route.query.region,
          timeHorizon: this.timeType
        })
        .then(res => {
          this.gcpCloudStorageApiRequestCount =
            res.data.cloudStorageApiRequestCount;
          this.gcpCloudStorageNetworkReceivedBytesCount =
            res.data.cloudStorageNetworkReceivedBytesCount;
          this.gcpCloudStorageNetworkSentBytesCount =
            res.data.cloudStorageNetworkSentBytesCount;
          this.gcpCloudStorageStorageObjectCount =
            res.data.cloudStorageStorageObjectCount;
          this.gcpCloudStorageStorageTotalByteSeconds =
            res.data.cloudStorageStorageTotalByteSeconds;
          this.gcpCloudStorageStorageTotalBytes =
            res.data.cloudStorageStorageTotalBytes;
          this.gcpXsData = res.data.xaxisData;
          this.initGCP();
        });
    },
    initGCP: function() {
      // 以下方法调用图标方法
      // 请求次数
      this.gcpCloudStorageApiRequestCountEchartsLine();
      // 接受字节
      this.gcpCloudStorageNetworkReceivedBytesCountEchartsLine();
      // 发送字节数
      this.gcpCloudStorageNetworkSentBytesCountEchartsLine();
      // 对象数
      this.gcpCloudStorageStorageObjectCountEchartsLine();
      // 总字节秒数
      this.gcpCloudStorageStorageTotalByteSecondsEchartsLine();
      // 总字节数
      this.gcpCloudStorageStorageTotalBytesEchartsLine();
    },
    // 请求次数
    gcpCloudStorageApiRequestCountEchartsLine: function() {
      this.gcpChartGcpcloudStorageApiRequestCount = this.$echarts.init(
        document.getElementById("requestCount")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageApiRequestCount.length;
      for (var i = 0; i < this.gcpCloudStorageApiRequestCount.length; i++) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageApiRequestCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageApiRequestCount.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#91c7ae",
            // color: "#91c7ae",
            lineStyle: { color: "#91c7ae" }
          }
        };
        seriesA.data = this.gcpCloudStorageApiRequestCount[i].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(this.gcpCloudStorageApiRequestCount[i].name);
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageApiRequestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageApiRequestCount.setOption(
        this.gcpCloudStorageApiRequestCountOption,
        true
      );
    },
    // 接收字节
    gcpCloudStorageNetworkReceivedBytesCountEchartsLine: function() {
      this.gcpChartGcpcloudStorageNetworkReceivedBytesCount = this.$echarts.init(
        document.getElementById("receivedBytesCount")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageNetworkReceivedBytesCount.length;
      for (
        var i = 0;
        i < this.gcpCloudStorageNetworkReceivedBytesCount.length;
        i++
      ) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageNetworkReceivedBytesCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageNetworkReceivedBytesCount.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#61a0a8",
            lineStyle: { color: "#61a0a8" }
          }
        };
        seriesA.data = this.gcpCloudStorageNetworkReceivedBytesCount[
          i
        ].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(
            this.gcpCloudStorageNetworkReceivedBytesCount[i].name
          );
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageNetworkReceivedBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageNetworkReceivedBytesCount.setOption(
        this.gcpCloudStorageNetworkReceivedBytesCountOption,
        true
      );
    },
    // 发送字节数
    gcpCloudStorageNetworkSentBytesCountEchartsLine: function() {
      this.gcpChartGcpcloudStorageNetworkSentBytesCount = this.$echarts.init(
        document.getElementById("sentBytesCount")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageNetworkSentBytesCount.length;
      for (
        var i = 0;
        i < this.gcpCloudStorageNetworkSentBytesCount.length;
        i++
      ) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageNetworkSentBytesCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageNetworkSentBytesCount.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#4671D5",
            lineStyle: { color: "#4671D5" }
          }
        };
        seriesA.data = this.gcpCloudStorageNetworkSentBytesCount[i].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(
            this.gcpCloudStorageNetworkSentBytesCount[i].name
          );
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageNetworkSentBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageNetworkSentBytesCount.setOption(
        this.gcpCloudStorageNetworkSentBytesCountOption,
        true
      );
    },
    // 对象数
    gcpCloudStorageStorageObjectCountEchartsLine: function() {
      this.gcpChartGcpcloudStorageStorageObjectCount = this.$echarts.init(
        document.getElementById("objectCount")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageStorageObjectCount.length;
      for (var i = 0; i < this.gcpCloudStorageStorageObjectCount.length; i++) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageStorageObjectCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageStorageObjectCount.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#FF9B40",
            lineStyle: { color: "#FF9B40" }
          }
        };
        seriesA.data = this.gcpCloudStorageStorageObjectCount[i].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(
            this.gcpCloudStorageStorageObjectCount[i].name
          );
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageStorageObjectCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageStorageObjectCount.setOption(
        this.gcpCloudStorageStorageObjectCountOption,
        true
      );
    },
    // 总字节秒数
    gcpCloudStorageStorageTotalByteSecondsEchartsLine: function() {
      this.gcpChartGcpcloudStorageStorageTotalByteSeconds = this.$echarts.init(
        document.getElementById("totalByteSeconds")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageStorageTotalByteSeconds.length;
      for (
        var i = 0;
        i < this.gcpCloudStorageStorageTotalByteSeconds.length;
        i++
      ) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageStorageTotalByteSeconds[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageStorageTotalByteSeconds.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#6a7985",
            lineStyle: { color: "#6a7985" }
          }
        };
        seriesA.data = this.gcpCloudStorageStorageTotalByteSeconds[i].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(
            this.gcpCloudStorageStorageTotalByteSeconds[i].name
          );
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageStorageTotalByteSecondsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageStorageTotalByteSeconds.setOption(
        this.gcpCloudStorageStorageTotalByteSecondsOption,
        true
      );
    },
    // 总字节数
    gcpCloudStorageStorageTotalBytesEchartsLine: function() {
      this.gcpChartGcpcloudStorageStorageTotalBytes = this.$echarts.init(
        document.getElementById("totalBytes")
      );
      // 往下写图表方法
      // 循环后端返回的数组 设置 name data 数据为 pointData 处理数据
      var customSeries = [];
      var customLegend = { x: "right", y: "10px", data: [] };
      // 循环从后端返回的数组
      this.colorList.length = this.gcpCloudStorageStorageTotalBytes.length;
      for (var i = 0; i < this.gcpCloudStorageStorageTotalBytes.length; i++) {
        var seriesA = {};
        seriesA.name = this.gcpCloudStorageStorageTotalBytes[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: {
            color:
              this.gcpCloudStorageStorageTotalBytes.length > 1
                ? params => {
                    return this.colorList[params.dataIndex];
                  }
                : "#c4aaaa",
            lineStyle: { color: "#c4aaaa" }
          }
        };
        seriesA.data = this.gcpCloudStorageStorageTotalBytes[i].pointData;
        customSeries.push(seriesA);
        if (customLegend.data.length < 4) {
          customLegend.data.push(this.gcpCloudStorageStorageTotalBytes[i].name);
        }
      }
      // 设置组件
      // tooltip ：提示框组件 ，      // legend：图例组件      // series：设置折线图
      // grid：直角坐标系内绘图网格      // xAxis：设置 x 轴       // yAxis ：设置 y 轴
      this.gcpCloudStorageStorageTotalBytesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: customLegend,
        series: customSeries,
        grid: { top: "35%", left: "3%", bottom: "3%", containLabel: true },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXsData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.gcpChartGcpcloudStorageStorageTotalBytes.setOption(
        this.gcpCloudStorageStorageTotalBytesOption,
        true
      );
    },
    // 切换时间
    changeTimeType: function() {
      this.queryBucketIndex();
    },
    changeTimeTypeALY: function() {
      this.register();
    },
    changeTimeGTypeGCP: function() {
      this.queryGcpCloudStorageIndex();
    },
    /******************AWS所有折线图********************************/
    init: function() {
      this.storageSizeLine();
      this.getPutRequestLine();
      this.internetTXLine();
      this.syncRXLine();
    },
    // 存储大小(字节)
    storageSizeLine: function() {
      this.chart = this.$echarts.init(document.getElementById("storageSize"));
      this.storageSizeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 存储大小
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.objectStorage.line.StorageSize")]
        },
        series: [
          {
            name: this.$t("alarms.objectStorage.line.StorageSize"),
            type: "line",
            data: this.storageSize,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chart.setOption(this.storageSizeOption);
    },
    // Get、put类请求数(次数)
    getPutRequestLine: function() {
      this.chartGetPutRequest = this.$echarts.init(
        document.getElementById("getPutRequest")
      );
      this.getPutRequestOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // get请求类 put请求类
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.objectStorage.line.GetRequestClass"),
            this.$t("alarms.objectStorage.line.PutRequestClass")
          ]
        },
        series: [
          {
            name: this.$t("alarms.objectStorage.line.GetRequestClass"),
            type: "line",
            data: this.getRequestCount,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.PutRequestClass"),
            type: "line",
            data: this.putRequestCount,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartGetPutRequest.setOption(this.getPutRequestOption);
    },
    //公网流出计量流量(字节)
    internetTXLine: function() {
      this.chartInternetTX = this.$echarts.init(
        document.getElementById("internetTX")
      );
      this.internetTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 公网流出计量流量
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.objectStorage.line.PublicNetworkOutgoingMeteredTraffic"
            )
          ]
        },
        series: [
          {
            name: this.$t(
              "alarms.objectStorage.line.PublicNetworkOutgoingMeteredTraffic"
            ),
            type: "line",
            data: this.internetTX,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartInternetTX.setOption(this.internetTXOption);
    },
    // 跨区域复制流入计量流量(字节)
    syncRXLine: function() {
      this.chartSyncRX = this.$echarts.init(document.getElementById("syncRX"));
      this.syncRXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 跨区域复制流入计量流量
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.objectStorage.line.CrossRegionReplicationOfInboundMeteringFlow"
            )
          ]
        },
        series: [
          {
            name: this.$t(
              "alarms.objectStorage.line.CrossRegionReplicationOfInboundMeteringFlow"
            ),
            type: "line",
            data: this.syncRX,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartSyncRX.setOption(this.syncRXOption);
    },
    /******************ALiyun所有折线图********************************/
    allAws: function() {
      this.availabilityRequestValidRateLine();
      this.validRequestCountTotalRequestCountLine();
      this.internetcdnsyncLine();
    },

    // 可用性/有效请求率%
    availabilityRequestValidRateLine: function() {
      this.chartAvailabilityRequestValidRate = this.$echarts.init(
        document.getElementById("availabilityRequestValidRate")
      );
      this.availabilityRequestValidRateOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 可用性/有效请求率%
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.objectStorage.line.availability"),
            this.$t("alarms.objectStorage.line.requestValidRate")
          ]
        },
        series: [
          {
            name: this.$t("alarms.objectStorage.line.availability"),
            type: "line",
            data: this.availability,
            itemStyle: {
              normal: {
                color: "#FF95CA",
                lineStyle: {
                  color: "#FF95CA"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.requestValidRate"),
            type: "line",
            data: this.requestValidRate,
            itemStyle: {
              normal: {
                color: "#FF5151",
                lineStyle: {
                  color: "#FF5151"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartAvailabilityRequestValidRate.setOption(
        this.availabilityRequestValidRateOption
      );
    },
    //有效请求数/总请求数(count)
    validRequestCountTotalRequestCountLine: function() {
      this.chartValidRequestCountTotalRequestCount = this.$echarts.init(
        document.getElementById("validRequestCountTotalRequestCount")
      );
      this.validRequestCountTotalRequestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 可用性/有效请求率%
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.objectStorage.line.validRequestCount"),
            this.$t("alarms.objectStorage.line.totalRequestCount")
          ]
        },
        series: [
          {
            name: this.$t("alarms.objectStorage.line.validRequestCount"),
            type: "line",
            data: this.validRequestCount,
            itemStyle: {
              normal: {
                color: "#FF8EFF",
                lineStyle: {
                  color: "#FF8EFF"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.totalRequestCount"),
            type: "line",
            data: this.totalRequestCount,
            itemStyle: {
              normal: {
                color: "#BE77FF",
                lineStyle: {
                  color: "#BE77FF"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartValidRequestCountTotalRequestCount.setOption(
        this.validRequestCountTotalRequestCountOption
      );
    },

    //公/内网/cdn/跨区域流入流出流量(Byte)
    internetcdnsyncLine: function() {
      this.chartInternetcdnsync = this.$echarts.init(
        document.getElementById("internetcdnsync")
      );
      this.internetcdnsyncOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        // 可用性/有效请求率%
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.objectStorage.line.internetSend"),
            this.$t("alarms.objectStorage.line.internetRecv"),
            this.$t("alarms.objectStorage.line.intranetSend"),
            this.$t("alarms.objectStorage.line.intranetRecv"),
            this.$t("alarms.objectStorage.line.cdnSend"),
            this.$t("alarms.objectStorage.line.cdnRecv"),
            this.$t("alarms.objectStorage.line.syncSend"),
            this.$t("alarms.objectStorage.line.syncRecv")
          ]
        },
        series: [
          {
            name: this.$t("alarms.objectStorage.line.internetSend"),
            type: "line",
            data: this.internetSend,
            itemStyle: {
              normal: {
                color: "#d3a4ff",
                lineStyle: {
                  color: "#d3a4ff"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.internetRecv"),
            type: "line",
            data: this.internetRecv,
            itemStyle: {
              normal: {
                color: "#AAAAFF",
                lineStyle: {
                  color: "#AAAAFF"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.intranetSend"),
            type: "line",
            data: this.intranetSend,
            itemStyle: {
              normal: {
                color: "#84C1FF",
                lineStyle: {
                  color: "#84C1FF"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.intranetRecv"),
            type: "line",
            data: this.intranetRecv,
            itemStyle: {
              normal: {
                color: "#A6FFFF",
                lineStyle: {
                  color: "#A6FFFF"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.cdnSend"),
            type: "line",
            data: this.cdnSend,
            itemStyle: {
              normal: {
                color: "#CF9E9E",
                lineStyle: {
                  color: "#CF9E9E"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.cdnRecv"),
            type: "line",
            data: this.cdnRecv,
            itemStyle: {
              normal: {
                color: "#95CACA",
                lineStyle: {
                  color: "#95CACA"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.syncSend"),
            type: "line",
            data: this.syncSend,
            itemStyle: {
              normal: {
                color: "#D2A2CC",
                lineStyle: {
                  color: "#D2A2CC"
                }
              }
            }
          },
          {
            name: this.$t("alarms.objectStorage.line.syncRecv"),
            type: "line",
            data: this.syncRecv,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          }
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      };
      this.chartInternetcdnsync.setOption(this.internetcdnsyncOption);
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.bucketName = this.$route.query.bucketName;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.$router.push({
        path: "/monitor/objectStorageDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          bucketName: this.bucketName,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName
        }
      });
    }
  }
};
</script>

<style scoped>
.ObjectStorage-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-12 {
  margin-bottom: 20px;
}
.ObjectStorage-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/object_storage/object_storage_dashboard/ObjectStorage.vue